// Which hosts count as pre-release. Features still proving themselves, such
// as Bluetooth setup and the onboarding simulate buttons, are offered here
// and nowhere else: temperaturestick.com never sees them.
//
//   beta.mytempstick.com   the beta site
//   *localhost                  temp-stick-dashboard.localhost and other dev vhosts
export function isBetaSite() {
  const host = (window.location && window.location.hostname) || '';
  return host.indexOf('beta.mytempstick.com') !== -1 || host.indexOf('localhost') !== -1;
}
